import React, { useState } from 'react'
import { Button, Col, Row, Image, Space } from 'antd'

const ExpandedData = ({ data }) => {

    const [isImageVisible, setIsImageVisible] = useState(false)
    const [selectedImage, setSelectedImage] = useState("")

    const handleImageClick = (image) => { setSelectedImage(image); setIsImageVisible(true) }

    const tableData = [
        { heading: "Course ID", data: data.id },
        { heading: "Type", data: data.type },
        { heading: "Title", data: data.title },
        { heading: "Batch", data: data.batch },
        { heading: "Slug", data: <a href={`https://codevpk.com/skills-development-program/${data.slug}`} target="_blank" rel="noopener noreferrer">{data.slug}</a> },
        { heading: "Abbreviation", data: data.abbreviation },
        { heading: "Summary", data: data.summary },
        { heading: "Languages", data: data.languages.join(', '), className: "text-capitalize" },
        { heading: "Learning Types", data: data.learningTypes.join(', '), className: "text-capitalize" },
        { heading: "Target Gender(s)", data: data.targetGenders.join(', '), className: "text-capitalize" },
        { heading: "Fee", data: data.currency + " " + data.fee },
        { heading: "Discount", data: data.discount + "%" },
        { heading: "Net Fee", data: data.currency + " " + data.netFee },
        { heading: "Payment Type", data: data.paymentType, className: "text-capitalize" },
        { heading: "Scholarship", data: data.scholarshipType + " " + data.scholarship + "%", className: "text-capitalize" },
        { heading: "Admission Status", data: data.isAdmissionOpen ? "Open" : "Closed" },
        { heading: "Last Date of Admission", data: window.dateFormat(data.lastDateOfAdmission, "dddd DD-MMM-YYYY") },
        { heading: "Sort Order", data: data.sortOrder },
        { heading: "Status", data: data.status, className: "text-capitalize" },
        { heading: "Date Created", data: window.dateFormat(data.createdAt, "dddd DD-MMM-YYYY, hh:mm:ss A") },
        { heading: "Date Updated", data: window.dateFormat(data.updatedAt, "dddd DD-MMM-YYYY, hh:mm:ss A") },
        { heading: "Banner", data: <Button type='link' className='p-0 h-auto' onClick={() => { handleImageClick(data.bannerURL) }}>Click to See</Button> },
        { heading: "Image", data: <Button type='link' className='p-0 h-auto' onClick={() => { handleImageClick(data.imageURL) }}>Click to See</Button> },
    ]

    const instructorForMalesDetails = [
        { heading: "Name", data: data.instructorForMales.name },
        { heading: "Profile URL", data: <a href={data.instructorForMales.profileURL} target="_blank" rel="noopener noreferrer">{data.instructorForMales.profileURL}</a> },
        { heading: "Photo URL", data: <Button type='link' className='p-0 h-auto' onClick={() => { handleImageClick(data.instructorForMales.photoURL) }}>Click to See</Button> },
        { heading: "Bio", data: data.instructorForMales.bio },
    ]
    const instructorForFemalesDetails = [
        { heading: "Name", data: data.instructorForFemales.name },
        { heading: "Profile URL", data: <a href={data.instructorForFemales.profileURL} target="_blank" rel="noopener noreferrer">{data.instructorForFemales.profileURL}</a> },
        { heading: "Photo URL", data: <Button type='link' className='p-0 h-auto' onClick={() => { handleImageClick(data.instructorForFemales.photoURL) }}>Click to See</Button> },
        { heading: "Bio", data: data.instructorForFemales.bio },
    ]

    const tableComponent = (heading, array) => {
        return <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover align-middle mb-0">
                <tbody>
                    <tr><th colSpan={2} className='text-center'>{heading}</th></tr>
                    {array.map((row, i) => {
                        return <tr key={i}>
                            <th style={{ minWidth: 180 }}>{row.heading}</th>
                            <td className={row.className || ""}>{row.data}</td>
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
    }

    return (
        <>
            <Row>
                <Col xs={24} lg={{ span: 14, offset: 5 }}>
                    <Space direction="vertical" size="large" className='w-100'>
                        {tableComponent("Course Details", tableData)}

                        {data.targetGenders.includes("male") && tableComponent("Instructor for Males", instructorForMalesDetails)}
                        {data.targetGenders.includes("female") && tableComponent("Instructor for Females", instructorForFemalesDetails)}
                    </Space>
                </Col>
            </Row>

            <Image preview={{ visible: isImageVisible, src: selectedImage, onVisibleChange: (value) => { setIsImageVisible(value) } }} />
        </>
    )
}

export default ExpandedData